<template>
  <div id="formulario-de-solicitacao">
    <div
      class="container container_com-fundo container_com-margem u-padding-grande u-margem-grande"
    >
      <loading
        :ativo="loading.visivel"
        :mensagem="loading.mensagem"
        name="loading-formulario"
      />
      <alerta :tipo="'erro'" :texto="mensagemDeErro" />
      <form @submit.prevent="cadastrarSolicitacao">
        <h2 class="titulo titulo_grande u-margem-inferior grande">
          Preencha todos os campos obrigatórios abaixo para solicitar o
          subsídio.
        </h2>
        <div
          role="alert"
          class="mensagem mensagem_cor-atencao u-margem-superior-grande u-margem-inferior-grande"
        >
          <i class="far fa-exclamation-circle mensagem__icone"></i>
          <div class="mensagem__conteudo">
            <h2 class="mensagem__titulo">Atenção:</h2>
            <p class="mensagem__texto">
              Ao conferir a renda do proponente, verifique se é a mesma
              cadastrada. Em caso de divergência atualize a renda no campo
              "Renda familiar comprovada".
              <strong
                >A irregularidade dessa informação pode levar o processo ao
                indeferimento</strong
              >
            </p>
            <p>
              Os campos com asterisco (*) são de preenchimento obrigatório, é
              necessário preenche-los para concluir a solicitação do subsidio.
            </p>
          </div>
        </div>
        <h3
          class="subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-gigante"
        >
          <i class="fal fa-user icone-de-titulo u-margem-direita-pequena"></i>
          Dados do proponente
        </h3>
        <div
          class="u-padding-esquerda-grande u-margem-superior-media u-margem-inferior-grande"
        >
          <div v-for="(proponente, index) in solicitacao.Proponentes">
            <span class="titulo titulo_pequeno">
              {{ index + 1 }}º Proponente
            </span>
            <div class="field is-horizontal u-margem-inferior-media">
              <div class="linha u-margem-superior-media">
                <div class="field coluna">
                  <span class="label">
                    <strong>Nome:</strong>
                  </span>
                  <span>{{ proponente.Nome }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>CPF:</strong>
                  </span>
                  <span>{{ proponente.Cpf }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>Telefone: </strong>
                  </span>
                  <span>{{ proponente.Telefone || "NÃO INFORMADO" }}</span>
                </div>
              </div>
            </div>
            <div v-if="proponente.Conjuge">
              <span class="titulo titulo_pequeno">
                {{ index + 1 }}º Cônjuge
              </span>
              <div class="field is-horizontal u-margem-inferior-grande">
                <div class="linha u-margem-superior-pequena">
                  <div class="field coluna">
                    <span class="label">
                      <strong>Nome:</strong>
                    </span>
                    <span>{{ proponente.Conjuge.Nome }}</span>
                  </div>
                  <div class="field coluna">
                    <span class="label">
                      <strong>CPF:</strong>
                    </span>
                    <span>{{ proponente.Conjuge.Cpf }}</span>
                  </div>
                  <div class="field coluna">
                    <span class="label">
                      <strong>Telefone: </strong>
                    </span>
                    <span>{{
                      proponente.Conjuge.Telefone || "NÃO INFORMADO"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="field-body field-body-linha">
            <div class="field">
              <span class="label">
                <strong> Renda familiar comprovada: </strong>
              </span>
              <span>
                <strong>R$ {{ solicitacao.RendaTotalComprovada }}</strong>
              </span>
            </div>
          </div>
        </div>
        <h3
          class="subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-gigante"
        >
          <i
            class="fal fa-home negrito icone-de-titulo u-margem-direita-pequena"
          ></i>
          Dados do imóvel
        </h3>
        <div class="u-padding-esquerda-media">
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label">Cidade</label>
              <input
                name="cidade"
                type="text"
                id="cidade"
                class="formulario__input"
                v-model="this.cidade.Nome"
                disabled
              />
            </div>
            <div class="grade__coluna grade__coluna_6">
              <label class="formulario__label">Empreendimento*</label>
              <select
                class="formulario__input"
                v-model="solicitacao.EmpreendimentoId"
                required
              >
                <option
                  v-for="empreendimento in empreendimentos"
                  :value="empreendimento.Id"
                  :selected="
                    empreendimento.Id === solicitacao.EmpreendimentoId
                      ? 'selected'
                      : ''
                  "
                >
                  {{ empreendimento.Nome }}
                </option>
              </select>
            </div>
            <div
              class="grade__coluna grade__coluna_2"
              v-if="ehEmpreendimentoDeCasaEApartamento()"
            >
              <label class="formulario__label">Tipo do imóvel*</label>
              <select
                v-model="solicitacao.TipoDeImovel"
                required
                class="formulario__input"
              >
                <option
                  v-for="tipoDeImovel in tiposDeImovel"
                  :value="tipoDeImovel.Id"
                  :selected="
                    tipoDeImovel.Id === solicitacao.TipoDeImovel
                      ? 'selected'
                      : ''
                  "
                >
                  {{ tipoDeImovel.Nome }}
                </option>
              </select>
            </div>
            <div
              class="grade__coluna grade__coluna_3"
              v-if="empreendimentoEstaSelecionado()"
            >
              <label class="formulario__label">Tipo do empreendimento</label>
              <input
                name="tipo-de-empreendimento"
                type="text"
                id="tipo-de-empreendimento"
                class="formulario__input"
                v-model="obterEmpreendimento().TipoDeEmpreendimento"
                disabled
              />
            </div>
          </div>
          <div class="grade__linha" v-if="empreendimentoEstaSelecionado()">
            <div class="grade__coluna grade__coluna_5">
              <label class="formulario__label">Construtora</label>
              <input
                name="nome-da-construtora"
                type="text"
                id="nome-da-construtora"
                class="formulario__input"
                v-model="construtora.Nome"
                disabled
              />
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label">CNPJ</label>
              <input
                name="cpnj"
                type="text"
                id="cnpj"
                class="formulario__input"
                v-model="construtora.Cnpj"
                disabled
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label">Conta</label>
              <input
                name="conta-da-construtora"
                type="text"
                id="conta-da-construtora"
                class="formulario__input"
                v-model="construtora.Conta"
                disabled
              />
            </div>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="matricula"
                >Matrícula*</label
              >
              <input
                name="matricula"
                type="tel"
                id="matricula"
                class="formulario__input"
                placeholder="Somente números"
                v-model="solicitacao.Matricula"
                required
              />
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="cep">Nº APF*</label>
              <input
                name="cep"
                type="tel"
                id="cep"
                class="formulario__input"
                placeholder="Somente números"
                v-model="solicitacao.Apf"
                required
              />
            </div>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="cep">CEP*</label>
              <input
                name="cep"
                type="tel"
                id="cep"
                class="formulario__input"
                placeholder="Somente números"
                v-model="solicitacao.Cep"
                v-mask="'99999-999'"
                required
              />
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="tipo-do-logradouro"
                >Tipo do logradouro*</label
              >
              <select
                class="formulario__input"
                v-model="solicitacao.TipoDeLogradouroId"
                required
              >
                <option
                  v-for="tipoDeLogradouro in tiposDeLogradouro"
                  :value="tipoDeLogradouro.Id"
                  :selected="
                    tipoDeLogradouro.Id === solicitacao.TipoDeLogradouroId
                      ? 'selected'
                      : ''
                  "
                >
                  {{ tipoDeLogradouro.Nome }}
                </option>
              </select>
            </div>
            <div class="grade__coluna grade__coluna_6">
              <label class="formulario__label" for="logradouro"
                >Logradouro*</label
              >
              <input
                id="logradouro"
                class="formulario__input"
                type="text"
                maxlenght="90"
                name="logradouro"
                placeholder="Ex: Afonso Pena, da Divisão, Lídia Baís, etc."
                v-model="solicitacao.Logradouro"
                required
              />
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_2">
                <label class="formulario__label" for="numero">Número*</label>
                <input
                  id="numero"
                  class="formulario__input"
                  type="number"
                  placeholder="EX: 481"
                  v-model="solicitacao.Numero"
                  number
                  required
                />
              </div>
              <div class="grade__coluna grade__coluna_3">
                <label class="formulario__label" for="bairro">Bairro*</label>
                <input
                  id="bairro"
                  class="formulario__input"
                  name="bairro"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: Centro, Santa Fé, Vila Carvalho..."
                  v-model="solicitacao.Bairro"
                  required
                />
              </div>
              <div
                class="grade__coluna grade__coluna_1"
                v-if="empreendimentoEstaSelecionado()"
              >
                <label
                  class="formulario__label"
                  for="bloco"
                  v-if="ehEmpreendimentoDeApartamento()"
                  >Bloco*
                </label>
                <label class="formulario__label" for="quadra" v-else
                  >Quadra/Bloco*</label
                >
                <input
                  id="quadra"
                  class="formulario__input"
                  v-model="solicitacao.BlocoOuQuadra"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: 1"
                  required
                />
              </div>
              <div
                class="grade__coluna grade__coluna_2"
                v-if="empreendimentoEstaSelecionado()"
              >
                <label
                  class="formulario__label"
                  for="apartamento"
                  v-if="ehEmpreendimentoDeApartamento()"
                  >Apartamento*
                </label>
                <label class="formulario__label" for="lote" v-else
                  >Lote/Apartamento*</label
                >
                <input
                  id="lote"
                  class="formulario__input"
                  v-model="solicitacao.ApartamentoOuLote"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: A"
                  required
                />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="complemento"
                  >Complemento</label
                >
                <input
                  id="complemento"
                  class="formulario__input"
                  type="text"
                  maxlenght="90"
                  placeholder="Ex: Casa 2"
                  v-model="solicitacao.Complemento"
                />
              </div>
            </div>
          </div>
        </div>

        <h3
          class="subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media"
        >
          <i
            class="fal fa-sack-dollar icone-de-titulo u-margem-direita-pequena"
          ></i>
          Dados do financiamento
        </h3>
        <div class="u-padding-esquerda-media">
          <div class="">
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="valor-da-compra-e-venda">
                  Valor de Comercialização*
                  <span class="tooltips">
                    <i
                      class="fa fa-info-circle"
                      id="tooltipValorDoFinanciamento"
                      aria-hidden="true"
                    ></i>
                    <span class="conteudo tooltip-top"
                      >O valor de comercialização, é o total da soma de todos os
                      campos em destaque.
                    </span>
                  </span>
                </label>
                <input
                  id="valor-da-compra-e-venda"
                  class="formulario__input"
                  type="text"
                  placeholder="130.000,00"
                  v-model="solicitacao.ValorDaCompraEVenda"
                  v-mask="'money'"
                  required
                />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="valor-de-avaliacao"
                  >Valor de avaliação*</label
                >
                <input
                  id="valor-de-avaliacao"
                  class="formulario__input"
                  type="text"
                  placeholder="130.000,00"
                  v-model="solicitacao.ValorDeAvaliacao"
                  v-mask="'money'"
                  required
                />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label
                  class="formulario__label"
                  for="valor-do-financiamento-aprovado"
                  >Valor do financiamento concedido*</label
                >
                <input
                  id="valor-do-financiamento-aprovado"
                  class="formulario__input"
                  type="text"
                  placeholder="90.000,00"
                  v-model="solicitacao.ValorDoFinanciamentoAprovado"
                  v-mask="'money'"
                  required
                />
              </div>
            </div>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="subsidio-governo-federal"
                >Subsídio Governo Federal*</label
              >
              <input
                id="subsidio-governo-federal"
                class="formulario__input"
                type="text"
                placeholder="14.000,00"
                v-model="solicitacao.SubsidioDoGovernoFederal"
                v-mask="'money'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="codigo-de-avaliacao"
                >Código de avaliação*</label
              >
              <input
                id="codigo-de-avaliacao"
                class="formulario__input"
                type="number"
                placeholder="Somente números"
                v-model="solicitacao.CodigoDeAvaliacao"
                number
                required
              />
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="data-de-avaliacao"
                >Data de avaliação*</label
              >
              <input
                id="data-de-avaliacao"
                class="formulario__input"
                type="date"
                v-model="solicitacao.DataDeAvaliacao"
                required
              />
            </div>
          </div>
          <div class="grade__linha u-padding-esquerda-pequena">
            <p class="u-margem-inferior-pequena titulo-negrito">
              <strong> Recursos Próprios </strong>
            </p>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="desconto-da-construtora"
                >Desconto da construtora na entrada</label
              >
              <input
                id="desconto-da-construtora"
                class="formulario__input"
                type="text"
                placeholder="10.000,00"
                v-model="solicitacao.DescontoConstrutora"
                v-mask="'money'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="participacao-necessaria"
                >Participação do proponente*</label
              >
              <input
                id="participacao-necessaria"
                class="formulario__input"
                type="text"
                placeholder="10.000,00"
                v-model="solicitacao.ParticipacaoDoSolicitante"
                v-mask="'money'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="subsidio-solicitado-agehab"
                >Subsídio solicitado AGEHAB</label
              >
              <input
                name="valorDoSubsidioDaAgehab"
                type="text"
                id="valorDoSubsidioDaAgehab"
                class="formulario__input"
                v-model="solicitacao.SubsidioDaAgehab"
                disabled
              />
            </div>
          </div>
        </div>
        <h3
          class="subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media"
        >
          <i
            class="fal fa-regular fa-file icone-de-titulo u-margem-direita-pequena"
          ></i>
          Documentos complementares
        </h3>
        <div class="grade__linha u-margem-inferior-grande">
          <div class="grade__coluna grade__coluna_8">
            <label
              class="formulario__label u-margem-inferior-grande"
              for="arquivo-de-declaracao"
              >Anexar abaixo a declaração com assinatura do proponente para dar
              continuidade a solicitação de subsídio.</label
            >
            <label for="arquivo" class="fileUpload">
              <i class="fa-solid fa-file-arrow-up"></i> Escolher arquivo
            </label>
            <input
              type="file"
              name="arquivo"
              id="arquivo"
              ref="files"
              style="visibility: hidden"
              v-on:change="carregarArquivo"
            />
            <label
              v-if="mensagemValidacaoDoArquivo"
              class="mensagemDeErroDoArquivo"
              >{{ mensagemValidacaoDoArquivo }}</label
            >

            <div class="u-margem-superior-media">
              <label v-if="arquivo" for="arquivo" class="nomeDoArquivo">
                {{ arquivo.name }}
                <button
                  type="button"
                  @click="removerArquivo()"
                  class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </label>
            </div>
          </div>
        </div>
        <div class="grade__linha grade__linha_alinhar-horizontal-direita">
          <router-link
            to="/consulta-por-cpf-para-mcmv-cidades"
            class="botao botao_cinza botao_medio"
            :class="{ 'is-disabled': loading.visivel }"
            >Cancelar</router-link
          >
          <button
            type="submit"
            :disabled="
              estaEmProcessoDeCadastroDaSolicitacao ||
              !solicitacao.SubsidioDaAgehab
            "
            class="botao botao_medio botao_cor-terciaria u-margem-esquerda-media"
            :class="{ 'is-loading': loading.visivel }"
          >
            Solicitar subsídio
          </button>
        </div>
      </form>

      <MensagemFlutuante
        :mensagemVisivel="mensagemVisivel"
        :titulo="tituloMensagem"
        :estilo="estiloMensagem"
        :texto="textoMensagem"
        @close="fecharMensagem"
      />
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Alerta from "../../shared/Alerta";
import MensagemFlutuante from "../../shared/MensagemFlutuante";
import Loading from "../../shared/Loading";

export default {
  name: "formulario-de-solicitacao-para-mcmv-cidades",
  directives: { mask: AwesomeMask },
  components: { Alerta, MensagemFlutuante, Loading },
  data() {
    const UM_MB = 1024 * 1024;
    return {
      extensoesValidas: ["pdf", "jpg", "jpeg", "png", "docx"],
      tamanhoMaximoDoArquivoPermitidoEmMB: 4 * UM_MB,
      estaEmProcessoDeCadastroDaSolicitacao: false,
      loading: {
        visivel: false,
      },
      mensagemDeErro: null,
      proponentes: [],
      cidade: this.cidade,
      empreendimentos: this.empreendimentos || [],
      tiposDeLogradouro: this.tiposDeLogradouro || [],
      tiposDeImovel: [
        {
          Id: null,
          Nome: "Selecione um tipo de imóvel",
        },
        {
          Id: 1,
          Nome: "Apartamento",
        },
        {
          Id: 2,
          Nome: "Casa",
        },
      ],
      solicitacao: {
        Proponentes: this.proponentes,
        RendaTotalComprovada: this.$moeda.formatar(
          this.$localStorage.obter("rendaFamiliarComprovada")
        ),
        ProjetoId: this.$route.params.projetoId,
        EmpreendimentoId: null,
        Matricula: null,
        Apf: null,
        Cep: null,
        Bairro: null,
        TipoDeLogradouroId: null,
        Logradouro: null,
        Numero: null,
        BlocoOuQuadra: null,
        ApartamentoOuLote: null,
        Complemento: null,
        CodigoDeAvaliacao: null,
        ValorDaCompraEVenda: null,
        ValorDoFinanciamentoAprovado: null,
        FgtsDoSolicitante: null,
        ParticipacaoDoSolicitante: null,
        SubsidioDoGovernoFederal: null,
        SubsidioDaAgehab: null,
        TipoDeImovel: null,
        DescontoConstrutora: null,
        DataDeAvaliacao: null,
        ValorDeAvaliacao: null,
      },
      arquivo: null,
      mensagemValidacaoDoArquivo: null,
      mensagemVisivel: false,
      textoMensagem: "",
      estiloMensagem: "",
      tituloMensagem: "",
    };
  },
  watch: {
    "solicitacao.EmpreendimentoId"(empreendimentoId) {
      if (!empreendimentoId) {
        this.solicitacao.SubsidioDaAgehab = null;
        return;
      }
      this.obterValorDoSubsidio(empreendimentoId);
    },
  },
  computed: {
    construtora() {
      const empreedimentoId = this.solicitacao.EmpreendimentoId;
      const empreendimento = this.empreendimentos.find(
        (e) => e.Id === empreedimentoId
      );
      return empreendimento ? empreendimento.Construtora : {};
    },
    somatorioDaRenda() {
      let somatorioDeRenda = 0;
      this.solicitacao.Proponentes.forEach((prop) => {
        somatorioDeRenda += somarRendaDosProponentes(prop);
      });
      return this.$moeda.formatar(somatorioDeRenda);

      function somarRendaDosProponentes(proponente) {
        let rendaDoTitular = proponente.Renda;
        let rendaDoConjuge =
          proponente.Conjuge != null ? proponente.Conjuge.Renda : 0;
        let somatorioDaRenda = rendaDoTitular + rendaDoConjuge;
        return somatorioDaRenda;
      }
    },
  },
  mounted() {
    const tooltip = document.getElementById("tooltipValorDoFinanciamento");
    tooltip.onmouseover = () => {
      const camposDeValor = document.querySelectorAll(".destacar-campos");
      for (let i = 0; i < camposDeValor.length; i += 1) {
        camposDeValor[i].className += " habilitado";
      }
    };

    tooltip.onmouseleave = () => {
      const camposDeValor = document.querySelectorAll(".destacar-campos");
      for (let i = 0; i < camposDeValor.length; i += 1) {
        camposDeValor[i].classList.remove("habilitado");
      }
    };
  },
  beforeCreate() {
    this.proponentes = this.$localStorage.obter("proponentes");

    if (this.proponentes.length == 0)
      this.$router.push({ name: "ConsultaPorCpfParaMcmvCidades" });

    this.cidade = this.proponentes[0].Cidade;
    this.$api
      .get("/Empreendimento/", {
        cidadeId: this.cidade.Id,
        projetoId: this.$route.params.projetoId,
      })
      .then((response) => {
        this.empreendimentos = [
          { Id: null, Nome: "Selecione um empreedimento" },
        ];
        this.empreendimentos = this.empreendimentos.concat(response.data);
        return response;
      })
      .catch((error) => {
        console.error(error);
      });

    this.$api.get("/TipoDeLogradouro").then(
      (response) => {
        this.tiposDeLogradouro = [{ Id: null, Nome: "Selecione um tipo" }];
        this.tiposDeLogradouro = this.tiposDeLogradouro.concat(response.data);
      },
      (error) => {
        console.error(error);
      }
    );
  },
  methods: {
    obterValorDoSubsidio(empreendimentoId) {
      const dto = {
        ProjetoId: this.solicitacao.ProjetoId,
        CidadeId: this.cidade.Id,
        RendaComprovada: this.$moeda.removerFormatacao(
          this.solicitacao.RendaTotalComprovada
        ),
        EmpreendimentoId: empreendimentoId,
      };
      this.exibirCarregamento();
      this.$api
        .post("/Projeto/ObterValorDoSubsidio", dto)
        .then((resposta) => {
          this.esconderCarregamento();
          const resultado =
            resposta && resposta.data && resposta.data.Resultado
              ? resposta.data.Resultado
              : null;
          if (resultado === null) {
            this.exibirMensagemDeErro(
              "A renda é incompatível com o projeto de subsídio"
            );
            this.solicitacao.SubsidioDaAgehab = null;
          } else if (resultado.PossuiSaldoDisponivel) {
            this.solicitacao.SubsidioDaAgehab = this.$moeda.formatar(
              resultado.Valor
            );
          } else {
            this.exibirMensagemDeErro(
              "Não há saldo disponível para a faixa de renda informada. Por favor, entre em contato com a AGEHAB"
            );
            this.solicitacao.SubsidioDaAgehab = null;
          }
        })
        .catch((error) => {
          this.esconderCarregamento();
          const mensagensDeErro =
            error.response && error.response.data
              ? error.response.data.Message
              : null;
          this.exibirMensagemDeErro(
            mensagensDeErro || "Ocorreu um erro ao obter o valor do subsídio"
          );
          this.solicitacao.SubsidioDaAgehab = null;
        });
    },
    cadastrarSolicitacao() {
      if (this.estaEmProcessoDeCadastroDaSolicitacao) {
        return;
      }

      if (!this.arquivo) {
        this.mensagemValidacaoDoArquivo =
          "Para continuar é necessário anexar um arquivo.";
        return;
      }

      this.estaEmProcessoDeCadastroDaSolicitacao = true;
      this.exibirCarregamento();

      this.configurarTipoDoImovel();
      const solicitacao = JSON.parse(JSON.stringify(this.$data.solicitacao));

      solicitacao.ValorDeAvaliacao = this.$moeda.removerFormatacao(
        solicitacao.ValorDeAvaliacao
      );
      solicitacao.ValorDaCompraEVenda = this.$moeda.removerFormatacao(
        solicitacao.ValorDaCompraEVenda
      );
      solicitacao.ValorDoFinanciamentoAprovado = this.$moeda.removerFormatacao(
        solicitacao.ValorDoFinanciamentoAprovado
      );
      solicitacao.FgtsDoSolicitante = this.$moeda.removerFormatacao(
        solicitacao.FgtsDoSolicitante
      );
      solicitacao.ParticipacaoDoSolicitante = this.$moeda.removerFormatacao(
        solicitacao.ParticipacaoDoSolicitante
      );
      solicitacao.SubsidioDoGovernoFederal = this.$moeda.removerFormatacao(
        solicitacao.SubsidioDoGovernoFederal
      );
      solicitacao.SubsidioDaAgehab = this.$moeda.removerFormatacao(
        solicitacao.SubsidioDaAgehab
      );
      solicitacao.RendaTotalComprovada = this.$moeda.removerFormatacao(
        solicitacao.RendaTotalComprovada
      );
      solicitacao.DescontoConstrutora = this.$moeda.removerFormatacao(
        solicitacao.DescontoConstrutora
      );

      let formData = this.criarFormData(solicitacao);

      this.$api
        .post("/solicitacao/Mcmv", formData)
        .then((response) => {
          const idDaSolicitacao = response.data;
          this.$localStorage.remover("proponentes");
          this.$router.push({
            name: "VisualizarSolicitacaoMcmv",
            query: { idDaSolicitacao },
          });
        })
        .catch((error) => {
          const mensagensDeErro = error.response.data.Message;
          this.esconderCarregamento();

          if (mensagensDeErro) {
            this.exibirMensagemDeErro(
              mensagensDeErro.split(",").join("<br />")
            );
          } else {
            this.exibirMensagemDeErro(
              "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte"
            );
          }

          this.estaEmProcessoDeCadastroDaSolicitacao = false;
          window.scrollTo(0, 0);
        });
    },
    criarFormData(solicitacao) {
      let formData = new FormData();
      formData.append("arquivo", this.arquivo);
      formData.append("parametros", JSON.stringify(solicitacao));
      return formData;
    },
    carregarArquivo(e) {
      this.arquivo = e.target.files[0];
      this.mensagemValidacaoDoArquivo = null;
      let extensao = this.arquivo.name.split(".")[1];
      if (!this.extensoesValidas.includes(extensao)) {
        this.arquivo = null;
        const mensagem =
          "Formato de declaração inválido! A declaração deve ser no formato pdf, docx, jpg ou png";
        this.exibirMensagemDeErro(mensagem);
        this.removerArquivo();
      }
      if (this.arquivo.size > this.tamanhoMaximoDoArquivoPermitidoEmMB) {
        this.arquivo = null;
        const mensagem =
          "O arquivo anexado excede o tamanho permitido. Por favor, escolha um arquivo de até 4 MB.";
        this.exibirMensagemDeErro(mensagem);
        this.removerArquivo();
      }
    },
    removerArquivo() {
      this.arquivo = null;
    },
    exibirCarregamento() {
      this.loading.visivel = true;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
    },
    configurarTipoDoImovel() {
      if (this.ehEmpreendimentoDeApartamento()) {
        this.solicitacao.TipoDeImovel = 1;
      } else {
        this.solicitacao.TipoDeImovel = 2;
      }
    },
    empreendimentoEstaSelecionado() {
      return this.solicitacao.EmpreendimentoId !== null;
    },
    exibirMensagemDeErro(mensagem) {
      this.mensagemDeErro = mensagem;
    },
    ocultarMensagemDeErro() {
      this.mensagemDeErro = null;
    },
    formatarMonetario(valor) {
      return this.$moeda.formatar(valor);
    },
    obterEmpreendimento() {
      const empreedimentoId = this.solicitacao.EmpreendimentoId;
      return this.empreendimentos.find((e) => e.Id === empreedimentoId);
    },
    obterTipoDeImovel() {
      const tipoDeImovelId = this.solicitacao.TipoDeImovel;
      return this.tiposDeImovel.find((e) => e.Id === tipoDeImovelId);
    },
    ehEmpreendimentoDeApartamento() {
      if (this.ehEmpreendimentoDeCasaEApartamento()) {
        const tipoDeImovel = this.obterTipoDeImovel();
        return tipoDeImovel !== null && tipoDeImovel.Id === 1;
      }
      const empreendimento = this.obterEmpreendimento();
      return empreendimento.TipoDeEmpreendimentoId === 1;
    },
    ehEmpreendimentoDeCasaEApartamento() {
      const empreedimento = this.obterEmpreendimento();
      return (
        empreedimento != null &&
        empreedimento.TipoDeEmpreendimentoId === 3 &&
        this.empreendimentoEstaSelecionado()
      );
    },
    exibirMensagemDeErro(mensagem) {
      let estiloDaMensagem = "erro";
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
      this.mensagemVisivel = true;
      this.textoMensagem = mensagem;
      this.estiloMensagem = estiloDaMensagem;
      this.tituloMensagem = tituloDaMensagem || "";
      setTimeout(() => {
        this.fecharMensagem();
      }, 10000);
    },
    fecharMensagem() {
      this.mensagemVisivel = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// FormularioDeSolicitacaoParaMcmvCidades.vue?2f25fcc0